import { render, staticRenderFns } from "./dlgEditPass.vue?vue&type=template&id=1a847a5f"
import script from "./dlgEditPass.vue?vue&type=script&lang=js"
export * from "./dlgEditPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports